export default "__VITE_ASSET__D19$AMVS__"